<div class="card-main-title std-bottom-margin">{{'PASSWORDS.EDIT_PASSWORD' | translate}}</div>
<div class="full-size-form-container" style="left:0px;right:0px;width: auto !important;">
    <form [formGroup]="passwordEditForm" style="width:100% !important;">
        <div class="form-group" style="width:100%;margin-right:0px;margin-left:0px;"
            [class.invalid-field]="requiredInSave('oldPassword') || wrongOldPassword">
            <label for="name" class="label-color">* {{'PASSWORDS.OLD_PASSWORD' | translate}}</label>
            <input [type]="getInputType()" (input)="wrongOldPassword = false" formControlName="oldPassword"
                class="form-control std-input-style">
            <small class="form-text text-muted errorCaption"
                *ngIf="!(requiredInSave('oldPassword') || wrongOldPassword)" style="height:8px"></small>
            <small class="form-text text-muted errorCaption" *ngIf="requiredInSave('oldPassword')"
                style="height:8px">{{"REQUIRED_FIELD" | translate}}</small>
            <small class="form-text text-muted errorCaption" *ngIf="!requiredInSave('oldPassword')&&wrongOldPassword"
                style="height:8px">{{"ERROR_WRONG_OLD_PASSWORD" | translate}}</small>
        </div>
        <div class="form-group" style="width:100%;margin-right:0px;margin-left:0px;"
            [class.invalid-field]="requiredInSave('newPassword') || shortPassword || isUnchangedPassword() || (!isConfirmPasswordValid && wrongConfirmPassword)">
            <label for="name" class="label-color">* {{'PASSWORDS.NEW_PASSWORD' | translate}}</label>
            <input [type]="getInputType()" formControlName="newPassword"
                (focusout)="isPasswordShort();isConfirmCorrect();isRequiredInSave('confirmPassword')"
                (input)="shortPassword = false;wrongConfirmPassword = false" class="form-control std-input-style">
            <small class="form-text text-muted errorCaption" *ngIf="!(requiredInSave('newPassword') || shortPassword)"
                style="height:8px"></small>
            <small class="form-text text-muted errorCaption" *ngIf="requiredInSave('newPassword')"
                style="height:8px">{{"REQUIRED_FIELD" | translate}}</small>
            <small class="form-text text-muted errorCaption" *ngIf="!requiredInSave('newPassword')&&shortPassword"
                style="height:8px">{{"SHORT_PASSWORD" | translate}}</small>
            <small class="form-text text-muted errorCaption" *ngIf="isUnchangedPassword()"
                style="height:8px">{{"PASSWORDS.UNCHANGED_PASSWORD" | translate}}</small>
            <small class="form-text text-muted errorCaption"
                *ngIf="!requiredInSave('newPassword') && !isConfirmPasswordValid && wrongConfirmPassword && !isUnchangedPassword() && !shortPassword"
                style="height:8px">{{"ERROR_CONFIRM_PASSWORD" | translate}}</small>
        </div>
        <div class="form-group" style="width:100%;margin-right:0px;margin-left:0px;"
            [class.invalid-field]="requiredInSave('confirmPassword') || wrongConfirmPassword">
            <label for="name" class="label-color">* {{'PASSWORDS.CONFIRM_PASSWORD' | translate}}</label>
            <input [type]="getInputType()" (focusout)="isConfirmCorrect();isRequiredInSave('confirmPassword')"
                (input)="wrongConfirmPassword = false; isConfirmPasswordValid= false" formControlName="confirmPassword"
                class="form-control std-input-style">
            <small class="form-text text-muted errorCaption"
                *ngIf="!(requiredInSave('confirmPassword') || wrongConfirmPassword)" style="height:8px"></small>
            <small class="form-text text-muted errorCaption"
                *ngIf="requiredInSave('confirmPassword') || isConfirmPasswordValid"
                style="height:8px">{{"REQUIRED_FIELD" | translate}}</small>
            <small class="form-text text-muted errorCaption"
                *ngIf="!requiredInSave('confirmPassword')&&wrongConfirmPassword && !isConfirmPasswordValid && !isUnchangedPassword() && !shortPassword"
                style="height:8px">{{"ERROR_CONFIRM_PASSWORD" | translate}}</small>
        </div>

        <div style="text-align: right;">
            <mat-checkbox class="comment-checkbox" style="margin-right: 3px;"
                [ngModelOptions]="{standalone: true}" [(ngModel)]="showPassword"><span
                    class="remember-label">{{ "PASSWORDS.VIEW_PASSWORD" | translate}}</span></mat-checkbox>
        </div>

        <div class="std-buttons-container">
            <div class="std-button std-primary-btn-style" type="button" (click)="save()">
                {{'USER.CREATION_FORM.SAVE' | translate}}</div>
            <div class="std-button std-alter-btn-style" type="button" (click)="cancel()" style="margin-left:0px;">
                {{'USER.CREATION_FORM.CANCEL' | translate}}</div>
        </div>
    </form>
</div>